module.exports = __webpack_public_path__ + "static/TamsinBailey-db368f25353e9a40f88e669796a595f4.jpg";